// Source: https://www.science.co.il/language/Locale-codes.php
const LanguageToLocale = {
  English: 'en-gb',
  Arabic: 'ar',
  'Simplified Chinese': 'zh-HANS', // Source: https://www.localeplanet.com/icu/zh-Hans/index.html
  'Traditional Chinese': 'zh-HANT', // Source: https://www.localeplanet.com/icu/zh-Hant/index.html
  Croatian: 'hr',
  French: 'fr-fr',
  German: 'de-de',
  Hebrew: 'he',
  Hindi: 'hi',
  Indonesian: 'id',
  Italian: 'it-it',
  Japanese: 'ja',
  Korean: 'ko',
  Malay: 'ms-my',
  Polish: 'pl',
  Portuguese: 'pt-pt',
  'Portuguese (Brazil)': 'pt-br',
  Slovenian: 'sl',
  Spanish: 'es-es',
  'Spanish (LATAM)': 'es-419', // Source: https://www.localeplanet.com/icu/es-419/index.html
  Thai: 'th',
  Vietnamese: 'vi',
  Burmese: 'my',
  Romanian: 'ro',
  Greek: 'el',
  Hungarian: 'hu',
  Turkish: 'tr',
  Czech: 'cs',
  Slovak: 'sk',
  Dutch: 'nl-nl',
};

export type Locale = keyof typeof LanguageToLocale;

export function getLocaleForLanguage(language: Locale): string {
  return LanguageToLocale[language] ?? 'en-gb';
}
